import { AboutLicensesFooter } from "shared/footer/AboutLicensesFooter";
import { AboutProjectFooter } from "shared/footer/AboutProjectFooter";
import { UserSettingsFooter } from "shared/footer/UserSettingsFooter";

interface Props {
  footerRef: React.Ref<HTMLDivElement>;
}

export const FooterView = (props: Props) => {
  return (
    <footer ref={props.footerRef} className="footer p-1">
      <div className="columns">
        <AboutProjectFooter />
        <AboutLicensesFooter />
        <UserSettingsFooter />
      </div>
    </footer>
  );
};
